export enum RequestExcusableStatus {
  Accepted = 1,
  Rejected = 2,
  Opened = 3,
  UnderDispute = 4,
  PartiallyAccepted = 5,
}
